'use client';

import { Divider, LoadingDark } from '@musinsa/mds';
import { useQuery } from '@tanstack/react-query';
import { twMerge } from 'tailwind-merge';

import { curatorQueries } from '../../query-factory';
import { SettlementCreateForm } from '../components';

interface SettlementSectionProps {
  className?: string;
}

export const SettlementSection = ({ className }: SettlementSectionProps) => {
  const { data: mypageData, isLoading } = useQuery(curatorQueries.mypage.data());

  const hasSettlementInfo = !!(
    mypageData?.accountInfo?.bankName && mypageData?.accountInfo?.bankAccountNumber
  );

  if (isLoading) {
    return (
      <div
        className={twMerge('w-full h-[208px] flex justify-center items-center py-12', className)}
      >
        <LoadingDark size="size24x24" />
      </div>
    );
  }

  // 수익 미발생 → 미노출. (SID-4695)
  if (!mypageData?.showAccountInfo) {
    return null;
  }

  // 등록 완료 → 메인에선 변경 UI 미노출. 정산 변경은 설정 > 정산 정보 관리(/edit/account)로 이전. (SID-4631)
  if (hasSettlementInfo) {
    return null;
  }

  // 수익 발생 + 미등록 → 등록 UI
  return (
    <div className={twMerge('w-full', className)}>
      <div className="px-[16px]! py-[12px]!">
        <Divider variant="line" />
      </div>
      <SettlementCreateForm />
    </div>
  );
};
